import { render, staticRenderFns } from "./FormInfo.vue?vue&type=template&id=7b596a7a&scoped=true&"
import script from "./FormInfo.vue?vue&type=script&lang=js&"
export * from "./FormInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormInfo.vue?vue&type=style&index=0&id=7b596a7a&prod&scoped=true&lang=css&"
import style1 from "./FormInfo.vue?vue&type=style&index=1&id=7b596a7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b596a7a",
  null
  
)

export default component.exports